/**
 * useImageUtils
 */
import { useMediaConfig } from './config';
import { formatImageUrl as formatUrl } from '../utils';

const useImageUtils = (configContext) => {

    const {
        imageLocation = 'https://img.mlbstatic.com/mlb-images/',
        imageFormatTemplate = {
            generic: 'ar_{ar},g_auto,q_auto:good,w_{width},c_fill,f_jpg',
            transparencyFit: 'q_auto:good,w_{width},c_fit,f_png',
        },
    } = useMediaConfig(configContext);

    const formatTemplateUrl = (imageStoragePath) => {

        if (!imageStoragePath) {

            return '';

        }

        const [
            path,
            asset,
        ] = imageStoragePath.match(/[^/]+\/[^/]+/g);
        return `${imageLocation}${path}/{formatInstructions}/${asset}`;

    };

    const formatImageUrl = ({ templateName = 'generic', ...options }) => formatUrl({
        formatInstructions: imageFormatTemplate[templateName],
        ...options,
    });

    return {
        formatTemplateUrl,
        formatImageUrl,
    };

};

export default useImageUtils;
